export const dataSource = [{
    name: 'Programming',
    cost: 175,
    engHours: 4,
    pVSa: 1.55,
    capacity: 320,
    plannedCapacity: 0.51,
    actualCapacity: 0.33,
    onTimePercent: 0.60,
    staffing: 1.25,
    research: 40,
    industry: 10,
    overhead: 125
}, {
    name: 'Slitter',
    cost: 310,
    engHours: 7.5,
    pVSa: 0.99,
    capacity: 160,
    plannedCapacity: 0.43,
    actualCapacity: 0.43,
    onTimePercent: 0.83,
    staffing: 0.75,
    research: 100,
    industry: 25,
    overhead: 0
}, {
    name: 'C1',
    cost: 110,
    engHours: 4,
    pVSa: 1.06,
    capacity: 240,
    plannedCapacity: 0.82,
    actualCapacity: 0.77,
    onTimePercent: 0.67,
    staffing: 0.80,
    research: 100,
    industry: 5,
    overhead: 0
}, {
    name: 'EI',
    cost: 150,
    engHours: 5,
    pVSa: 1.33,
    capacity: 160,
    plannedCapacity: 1.23,
    actualCapacity: 0.93,
    onTimePercent: 0.96,
    staffing: 1.15,
    research: 60,
    industry: 0,
    overhead: 0
}, {
    name: 'Machining',
    cost: 120,
    engHours: 4,
    pVSa: 1.33,
    capacity: 320,
    plannedCapacity: 0.41,
    actualCapacity: 0.36,
    onTimePercent: 0.06,
    staffing: 0.75,
    research: 60,
    industry: 20,
    overhead: 100
}, {
    name: 'NDT',
    cost: 75,
    engHours: 1.5,
    pVSa: 1.05,
    capacity: 160,
    plannedCapacity: 0.71,
    actualCapacity: 0.68,
    onTimePercent: 0.37,
    staffing: 2.30,
    research: 190,
    industry: 0,
    overhead: 0
}, {
    name: 'Processing',
    cost: 40,
    engHours: 1.75,
    pVSa: 0.96,
    capacity: 480,
    plannedCapacity: 0.82,
    actualCapacity: 0.85,
    onTimePercent: 0.57,
    staffing: 1.05,
    research: 360,
    industry: 20,
    overhead: 10
}, {
    name: 'XCT',
    cost: 125,
    engHours: 3,
    pVSa: 0.87,
    capacity: 352,
    plannedCapacity: 0.81,
    actualCapacity: 0.94,
    onTimePercent: 0.37,
    staffing: 0.90,
    research: 265,
    industry: 0,
    overhead: 0
}];

export const operations = [
    { name: 'Throughput', number: 0.21, percentage: 0.87 },
    { name: 'Equipment Utilization', number: 0.56, percentage: 0.27 },
    { name: 'Labor Productivity', number: 0.07, percentage: 0.62 },
    { name: 'Quality', number: 1, percentage: 1 },
    { name: 'Average Training Level', number: 2, percentage: 0.5 },
    { name: 'Equipment Readiness Level', number: 50, percentage: 0.10 }
];